<div class="custom-mat-dialog-form">
  <div>
    <h3>Create Compatibility Group</h3>
  </div>
  <br />
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-12 form-group">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Name</mat-label>
            <input matInput formControlName="globalControllerGroupName" required>
          </mat-form-field>
          @if (form.get('globalControllerGroupName')?.invalid && (form.get('globalControllerGroupName')?.dirty || form.get('globalControllerGroupName')?.touched)) {
            <p>
              @if (form.get('globalControllerGroupName')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
            </p>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 form-group">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Confirm Name</mat-label>
            <input matInput formControlName="confirmName" required>
          </mat-form-field>
          @if ((form.get('confirmName')?.dirty || form.get('confirmName')?.touched)) {
            <p>
              @if (form.get('confirmName')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (form.hasError('namesNotMatching') && form.get('confirmName')?.value) {
                <mat-error>Names do not match</mat-error>
              }
            </p>
          }
        </div>
      </div>
      <div class="row">
        <div class="panel-body" style="display: flex; justify-content: space-between; align-items: center;">
          <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-grey">
            <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
            Cancel
          </button>
          <button mat-raised-button type="submit" class="btn button-fix button-color-fix-orange" [disabled]="!form.valid">
            Create
            <mat-icon class="icon-color-fix">save</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
